// extracted by mini-css-extract-plugin
export default {"list":"dYhc4P"};